import { AfterViewInit, Component, OnInit, RootRenderer } from '@angular/core';
import { Router } from '@angular/router';
import { ServeyService } from 'src/app/core/services/survey.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit {
  constructor(
    private router: Router,
  ) { }

  ngOnInit() {
  }
}
